import React, { useEffect } from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { gameActions } from '../../actions';

// Components
import { GameForm } from './form';
import { GameSetup } from './setup';
import { GamePlayers } from './players';
import { GameDebrief } from './debrief';
import GameProposals from './debrief_proposals';
import GameProposalsV2 from './debrief_proposals_v2';
import GameAggregate from './debrief_aggregate';
import GameAggregateV2 from './debrief_aggregate_v2';
import { GameLeaderboard } from './leaderboard';

const Form = () => {
  // Hooks
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const { id } = useParams();

  useEffect(() => {
    dispatch(gameActions.fetchGames(id));
  }, [dispatch, id]);

  // LOGIC
  const SetupComponent =
    game && game.data && game.data.access_type === 'lti-hbp'
      ? GameSetup
      : GameForm;

  const isV2 = game?.data?.version === 2 ? true : false;

  return (
    <div>
      {game && game.data && (
        <div style={{ minHeight: '100vh' }}>
          <Routes>
            <Route index element={<SetupComponent />} />
            <Route path='setup' element={<SetupComponent />} />
            <Route path='players' element={<GamePlayers />} />
            <Route path='debrief/overview' element={<GameDebrief />} />
            <Route
              path={`debrief/proposals`}
              element={isV2 ? <GameProposalsV2 /> : <GameProposals />}
            />
            <Route
              path='debrief/aggregate'
              element={isV2 ? <GameAggregateV2 /> : <GameAggregate />}
            />
            <Route path='debrief/leaderboard' element={<GameLeaderboard />} />
          </Routes>
        </div>
      )}
    </div>
  );
};

export { Form as GameItem };
